"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Right(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "5.657 3.657 5.656 10.656 12.657 10.657 12.657 12.657 3.657 12.657 3.657 3.657", transform: "rotate(-135 8.157 8.157)" })));
}
exports.default = Right;
//# sourceMappingURL=Right.js.map